import React, { Component, ReactNode } from 'react';
import { RuleJsonModel } from '../../domain/collection/rule/FlowDomains';
import { ConfirmPopup } from 'primereact/confirmpopup';
import { customConfirm } from './CustomPopupConfirm';
import CustomBadge from './CustomBadge';

class CustomTabv2 extends Component<Props, State> {
  public state = new State();

  public render() {
    const { tab, onClick, router, itemToolsMenu, isDashboard, ghost, isContainer = true, isAdminPage = false } = this.props;

    const selectedTab = this.props.selectedTab || this.state.selectedTab;
    return (
      <div
        className={`w-full ${router == undefined || !router ? 'h-full' : ''}  flex flex-col ${isDashboard ? 'max-h-[calc(100dvh-16rem)]' : 'overflow-y-hidden'}  `}
      >
        <div className={`flex justify-start items-center w-full border-b ${isContainer && 'pl-5'}`}>
          <div
            className={`${ghost ? 'bg-transparent' : 'bg-white'} flex ${isAdminPage ? 'justify-center' : 'justify-start'} items-start w-full h-full gap-x-4`}
          >
            {(tab?.filter((t) => t != undefined && (t.visible == undefined ? true : t.visible)) as CustomTabItem[]).map((t, i) => {
              return (
                <div
                  key={i}
                  data-testid={t.testid}
                  onClick={(e: any) => !t.disable && this.setState({ selectedTab: t.key }, () => onClick?.(e, t.key))}
                  className={`${t.disable ? 'cursor-not-allowed' : 'cursor-pointer'} ${selectedTab == t.key ? ' border-b-[#4F4F4F] text-[#4F4F4F] border-b-[2px] opacity-100 ' : ghost ? 'text-[#4F4F4F] bg-transparent opacity-50' : 'text-[#4F4F4F] bg-white opacity-50'} px-2 pb-2 text-sm h-full flex justify-center items-center`}
                >
                  <div className={'flex gap-x-1 shrink-0 items-center'}>
                    {t.icon}
                    {t.label}
                    {t.badgeValue && t.badgeValue != '0' && <CustomBadge value={t.badgeValue} color='#458EF7' />}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        {(router == undefined || !router) && <div className={'flex h-full w-full'}>{tab?.find((t) => t?.key == selectedTab)?.content}</div>}
      </div>
    );
  }

  public componentDidMount() {
    const { tab, selectedTab } = this.props;
    if (tab && tab.length > 0 && tab[0] != undefined) {
      this.setState({ selectedTab: selectedTab || tab[0].key });
    }
  }
}

interface Props {
  tab: Array<CustomTabItem | undefined>;
  itemToolsMenu?: ReactNode;
  onClick?: (e: any, tab: string) => void;
  router?: boolean;
  selectedTab?: string;
  ghost?: boolean;
  isDashboard?: boolean;
  isContainer?: boolean;
  isAdminPage?: boolean;
}

class State {
  selectedTab: string | undefined;
}

export interface CustomTabItem {
  key: string;
  label: string;
  content?: ReactNode | any;
  icon?: ReactNode;
  visible?: boolean;
  disable?: boolean;
  badgeValue?: string;
  testid?: string;
}

export default CustomTabv2;
